import React from 'react';
import useProblem from './hooks/useProblem.js';
import Table from './Table.js';

const Problem = () => {
  const { handleReload, loading, cluster, checkExp, checkStand, setCheckExp, setCheckStand } = useProblem();
// debugger;
  return (
    <section className="section">
      <div className="container">
        <div className="has-text-centered">
          <button className="button is-dark" onClick={handleReload}>
            <span className="icon">
              <i className="fas fa-sync-alt" aria-hidden="true"></i>
            </span>
            <span>Reload</span>
          </button>
        </div>
      </div>
      <section className="section">{console.log('PROBLEM.JS')}
        <div className="is-centered has-text-centered">
          <div className="columns is-centered">
            {loading ? <div className="lds-dual-ring"></div> : <Table {...{cluster, checkExp, checkStand, setCheckExp, setCheckStand}} />}
          </div>
        </div>
      </section>
    </section>
  )
}

export default Problem;
